import { render, staticRenderFns } from "./editVersion.vue?vue&type=template&id=183e6633&scoped=true&"
import script from "./editVersion.vue?vue&type=script&lang=js&"
export * from "./editVersion.vue?vue&type=script&lang=js&"
import style0 from "./editVersion.vue?vue&type=style&index=0&id=183e6633&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e6633",
  null
  
)

export default component.exports